export const particlesJson = {
  "particles": {
    "number": {
      "value": 700,
      "density": {
        "enable": false
      }
    },
    "color": {
      "value": "#ccc"
    },
    "shape": {
      "type": "edge",
      "stroke": {
        "width": 0
      },
      "polygon": {
        "nb_sides": 4
      }
    },
    "opacity": {
      "value": 0.8,
      "random": true,
      "anim": {
        "enable": true,
        "speed": 0.8,
        "opacity_min": 0.4,
        "sync": false
      }
    },
    "size": {
      "value": 1.0,
      "random": true,
      "anim": {
        "enable": true,
        "speed": 10,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": false
    },
    "move": {
      "enable": true,
      "speed": 6,
      "direction": "bottom-right",
      "random": true,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": true,
        "rotateX": 10730,
        "rotateY": 3000
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": false,
      },
      "onclick": {
        "enable": false,
      },
      "resize": true
    }
  },
  "retina_detect": true
};